"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ProgressStep;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _checkmark = _interopRequireDefault(require("@ux/icon/checkmark"));
/**
 * Possible status types
 *
 * @type {object}
 */
const STATUS = {
  Incomplete: 'incomplete',
  Current: 'current',
  Complete: 'complete'
};

/**
 * ProgressStep component, representing each individual step.
 *
 * @param {Object} props Props
 * @param {String} status Status of ProgressStep completion
 * @param {String} href Source of ProgressStep
 * @param {Function} onClick Action to take place when ProgressStep clicked
 * @param {[React.Component]} children Components to be displayed beneath the ProgressStep component
 * @param {number} tabIndex index value
 * @returns {ReactElement} ReactElement
 */
function ProgressStep(_ref) {
  let {
    status,
    href,
    onClick,
    children,
    tabIndex
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("li", {
    role: "status",
    "aria-live": "polite",
    "aria-label": `step ${status}`,
    className: `ux-tabs-wiz-step-${status}`
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: href,
    onClick: onClick,
    className: 'ux-tabs-wiz-link',
    tabIndex: href ? null : tabIndex
  }, status === 'complete' && /*#__PURE__*/_react.default.createElement(_checkmark.default, {
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "ux-tabs-wiz-txt"
  }, children)));
}
ProgressStep.propTypes = {
  /** Status required, indicates completion status */
  status: _propTypes.default.string.isRequired,
  /** ProgressStep source */
  href: _propTypes.default.string,
  /** Function to run when clicked */
  onClick: _propTypes.default.func,
  /** Nodes displayed under ProgressStep component */
  children: _propTypes.default.node,
  /** Developer indicates tabIndex */
  tabIndex: _propTypes.default.oneOf([-1, 0])
};
ProgressStep.defaultProps = {
  status: STATUS.Incomplete,
  tabIndex: 0
};
ProgressStep.Status = STATUS;